import { cn } from '@/lib/cn';

type Props = {
  className?: string;
};

/**
 * Pulsing placeholder block. Use a wrapper to control width/height; default
 * is a single text-line-height bar at the surrounding text size.
 */
export function Skeleton({ className }: Props) {
  return (
    <div
      aria-hidden
      className={cn(
        'h-4 w-full animate-pulse rounded bg-[var(--color-surface-muted)]',
        className,
      )}
    />
  );
}

/**
 * Stacks N skeleton lines with a consistent gap. Useful as the body of a
 * loading list or table.
 */
export function SkeletonList({ rows = 3, className }: { rows?: number; className?: string }) {
  return (
    <div className={cn('space-y-2.5', className)} aria-busy="true" aria-live="polite">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className="h-5" />
      ))}
    </div>
  );
}
